import { Profession, ParsedProfession } from './types';

const buildPaymentSizeStr = (min: string, max: string) => {
  if (!+min && !+max) return null;
  let minStr = null;
  let maxStr = null;
  if (+min) minStr = `от ${min} `;
  if (+max) maxStr = `до ${max} `;
  return (minStr || '') + (maxStr || '') + '₽';
};

const parseProfession = (item: Profession): Readonly<ParsedProfession> =>
  Object.freeze({
    id: item!.id || '',
    name: item!.name || '',
    image: item.image ? item.image!.big || item.image!.original : '',
    main: {
      description: item!.description || '',
      contraindicationsDesc: item!.contraindications_desc || '',
      interestsDesc: item!.interests_desc || '',
      qualitiesDesc: item!.qualities_desc || '',
    },
    sidebar: {
      paymentSize: buildPaymentSizeStr(item!.pay_min, item!.pay_max),
      workSphere: item!.work_sphere || '',
      workType: item!.work_type || '',
      profStandards: item!.prof_standards || [],
      workPlace: item!.work_place || [],
      payLevel: item!.pay_level || '',
      educationRequired: item!.education_required || '',
      links: item!.links || [],
    },
  });

export default parseProfession;



// WEBPACK FOOTER //
// ./src/services/api/professions/utils/parseProfession.ts